if(typeof lazySizes === 'undefined'){
	/*! lazysizes - v4.1.8 */
  !function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
  /*! ls.rias.min.ks - v4.1.8 */
  !function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

var onSale = false;
var soldOut = false;
var isNew = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true,
        // Placeholder
        showPlaceholderProductList: true,
        placeholderProductPerRow: 6,
        filterTreeMobileStyle: 'style2',
    }
};

/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  isNew = data.tags.includes('new:true') // Check if product is new
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Grid Width class
  itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data));
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Award Badge
  if(data.tags.includes("discount:iCAST-best-of-show")) {
    var badgeHtml = "<div class='award-badge'><img alt='iCAST Best of Show' src='https://media.purefishing.com/i/purefishing/2021-NPS-Winner-Best-Of_Show'></div>";
    itemHtml = itemHtml.replace(/{{itemAwardBadge}}/g, badgeHtml);
  } else if(data.tags.includes("discount:iCAST-best-of-category")) {
    var badgeHtml = "<div class='award-badge'><img alt='iCAST Best of Show' src='https://media.purefishing.com/i/purefishing/2021-NPS-Winner-Best_Of_Category'></div>";
    itemHtml = itemHtml.replace(/{{itemAwardBadge}}/g, badgeHtml);
  } else {
    itemHtml = itemHtml.replace(/{{itemAwardBadge}}/g, "");
  }
  // Add Price
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // Add Custom Metafields
  itemHtml = itemHtml.replace(/{{itemCustomMetafields}}/g, buildCustomMetafields(data));
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);

  // Add data json
    itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(data.json));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  itemHtml = itemHtml.replace(/{{itemSku}}/g, data.variants[0].sku);
  return itemHtml;
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  // For List View
  /*** Prepare data ***/
  var images = data.images_info;
  // Displaying price base on the policy of Shopify, have to multiple by 100
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/
  // Get Template
  var itemHtml = bcSfFilterTemplate.productListItemHtml;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);
  // Add Custom class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  // Add Label
  itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
  // Add TAG Label
  itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false));
  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
  // Add Price
  var itemPriceHtml = buildPrice(data, onSale, priceVaries);
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
  // Description
  var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
  itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
  // itemActiveSwapClass
  var itemActiveSwapClass = bcSfFilterConfig.custom.active_image_swap ? 'has-bc-swap-image' : '';
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, itemActiveSwapClass);
  // Add main attribute
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  return itemHtml;
  // End For List View
};
/************************** END BUILD PRODUCT LIST **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function buildGridWidthClass() {
  var gridWidthClass = '';
  // On PC
  switch (bcSfFilterConfig.custom.products_per_row) {
    case 2:
      gridWidthClass = 'bc-sf-filter-grid-width-2';
      break;
    case 3:
      gridWidthClass = 'bc-sf-filter-grid-width-3';
      break;
    case 5:
      gridWidthClass = 'bc-sf-filter-grid-width-5';
      break;
    default:
      gridWidthClass = 'bc-sf-filter-grid-width-4';
      break;
  }
  // On Mobile
  switch (bcSfFilterConfig.custom.products_per_row_mobile) {
    case 1:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-1';
      break;
    case 3:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-3';
      break;
    default:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-2';
      break;
  }
  return gridWidthClass;
}

function buildImages(data) {
  var thisSku = data.variants[0].sku;
  var mediaSetId = collectionAmplienceMediaSet[thisSku];
  if(typeof data.metafields !== "undefined") {
    data.metafields.forEach(function(meta) {
      if(meta.namespace == "amplience" && meta.key == "gallery_set") {
        mediaSetId = meta.value;
      }
    });
  }
  var html = '';
  // Build Main Image
  var thumbUrl = images.length > 0 ? images[0]['src'] : bcSfFilterConfig.general.no_image_url;
  const secondImageUrl = images.length > 1 ? images[1]['src'] : thumbUrl;
  const useSecondImage = window.theme.useSecondImage;
  
  if(mediaSetId) {
    html += '<img class="bc-sf-filter-product-item-main-image"' +
            'alt="' + data.title + '"'+
            'src="https://media.purefishing.com/s/purefishing/' + mediaSetId + '?$collection_tile$"'+
            '/>';
  } else {
    if(images.length > 0){
        if(useSecondImage){
          html += '<img class="bc-sf-filter-product-item-main-image"' +
                'alt="' + data.title + '"'+
                'src="' + bcsffilter.optimizeImage(secondImageUrl) + '"'+
                'srcset="' + bcsffilter.optimizeImage(secondImageUrl,'medium') + ' ' + '240w,' + ' ' + bcsffilter.optimizeImage(secondImageUrl,'large') + ' ' + '480w,' + ' ' + bcsffilter.optimizeImage(secondImageUrl,'grande') + ' ' + '600w' + '"' +
                'sizes="50vw"' +
                '/>';    
        } else {
            html += '<img class="bc-sf-filter-product-item-main-image"' +
                'alt="' + data.title + '"'+
                'src="' + bcsffilter.optimizeImage(thumbUrl) + '"'+
                'srcset="' + bcsffilter.optimizeImage(thumbUrl,'medium') + ' ' + '240w,' + ' ' + bcsffilter.optimizeImage(thumbUrl,'large') + ' ' + '480w,' + ' ' + bcsffilter.optimizeImage(thumbUrl,'grande') + ' ' + '600w' + '"' +
                'sizes="50vw"' +
                '/>';    
        } 
      } else {
      html += '<img class="bc-sf-filter-product-item-main-image"' +
              'alt="' + data.title + '"'+
              'src="' + bcsffilter.optimizeImage(thumbUrl) + '"'+
              'srcset="' + bcsffilter.optimizeImage(thumbUrl,'medium') + ' ' + '240w,' + ' ' + bcsffilter.optimizeImage(thumbUrl,'large') + ' ' + '480w,' + ' ' + bcsffilter.optimizeImage(thumbUrl,'grande') + ' ' + '600w' + '"' +
              'sizes="50vw"' +
              '/>';    
    }
  }

  // Build Image Swap
  if (bcSfFilterConfig.custom.active_image_swap) {
    html += '<img class="bc-sf-filter-product-item-flip-image"' +
              'src="' + bcsffilter.optimizeImage(secondImageUrl) + '"' +
              'srcset="' + bcsffilter.optimizeImage(secondImageUrl,'medium') + ' ' + '240w,' + ' ' + bcsffilter.optimizeImage(secondImageUrl,'large') + ' ' + '480w,' + ' ' + bcsffilter.optimizeImage(secondImageUrl,'grande' ) + ' ' + '600w' + '"' +
              'sizes="50vw"' +
              '/>';
  }
  return html;
}

function buildVendor(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_vendor) {
    html = bcSfFilterTemplate.vendorHtml;
  }
  return html;
}

function buildCustomMetafields(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_custom_metafields) {
    //console.log(data.title);
    //console.log(data.variants);
    //console.log(data.variants[0].sku);
    html = '<p class="bc-sf-filter-product-item-custom-metafields"><div data-bv-show="rating_summary" data-bv-productId="' + data.variants[0].sku + '"></div></p>';
  }
  return html;
}

function buildPrice(data) {
  var thisSku = data.variants[0].sku;
  var currency = Shopify.currency.active.toLowerCase();
  var thisCurrencyPrice = "";
  if(typeof collectionProductPricing !== 'undefined' && typeof collectionProductPricing[thisSku] !== 'undefined') {
  	var pricing = collectionProductPricing[thisSku];
    if(typeof pricing[currency] !== 'undefined') {
    	thisCurrencyPrice = pricing[currency];
    }
  }
  
  var html = '';
  if (bcSfFilterConfig.custom.show_price && (thisCurrencyPrice || theme.region == "US")) {
    html = '<p class="bc-sf-filter-product-item-price">';
    if ( theme.commerceEnabled || theme.showPriceWhenCommerceDisabled ) {
      html += '<span class="price-from">' + (window.theme.strings.from) + '</span> ';
    }
    
    if ( theme.commerceEnabled ) {
      if (onSale) {
        html += '<s>' + bcsffilter.formatMoney(data.compare_at_price_min) + '</s> ';
        if(theme.region == "US") {
          html += '<span class="bc-sf-filter-product-item-sale-price" tabindex="0">' + bcsffilter.formatMoney(data.price_min) + '</span>';
        } else {
          html += '<span class="bc-sf-filter-product-item-sale-price" tabindex="0">' + bcsffilter.formatMoney(thisCurrencyPrice) + '</span>';
        }
      } else {
        // if (priceVaries) {
        //   html += (bcSfFilterConfig.label_basic.from) + ' ';
        // }
        if(theme.region == "US") {
      html += '<span class="bc-sf-filter-product-item-regular-price" tabindex="0">' + bcsffilter.formatMoney(data.price_min) + '</span>';
        } else {
          html += '<span class="bc-sf-filter-product-item-regular-price" tabindex="0">' + bcsffilter.formatMoney(thisCurrencyPrice) + '</span>'; 
        }
      }
    }
    else if ( theme.showPriceWhenCommerceDisabled ) {
      if(theme.region == "US") {
        html += '<span class="bc-sf-filter-product-item-regular-price" tabindex="0">' + bcsffilter.formatMoney(data.price_min) + '</span>';
      } else {
        html += '<span class="bc-sf-filter-product-item-regular-price" tabindex="0">' + bcsffilter.formatMoney(thisCurrencyPrice) + '</span>'; 
      }
    }
    else {
      // do nothing
    }
    html += '</p>';
  }
  return html;
}

function buildLabels(data) {
  soldOut = !data.tags.includes("in_stock") && !data.tags.includes("online:60");
  // Build Sold out label
  var soldOutLabel = '';
  if (theme.commerceEnabled && bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
    soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Sale label
  var saleLabel = '';
  if (theme.commerceEnabled && bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
    saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, '');
  }
  // Build New label
  var newLabel = ''
  if (isNew) {
    newLabel = bcSfFilterTemplate.newLabelHtml.replace(/{{style}}/g, '')
  }
  // Build Labels
  return newLabel + saleLabel + soldOutLabel;
}
// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels(data, showall) {
  if (showall) {
    var tagLabel = '';
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
        }
      }
    }
  } else {
    var tagLabel = '';
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
          break;
        }
      }
    }
  }
  return tagLabel;
}
/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      var paramSort = this.queryParams.sort || '';
      // Build content
      var sortingItemsHtml = '';
      var activeSortTranslated = '';
      for (var k in sortingArr) {
        var displayValue = sortingArr[k];
        if(typeof translatedSorted !== "undefined" && typeof translatedSorted[k] !== "undefined") {
          displayValue = translatedSorted[k];
        }

        activeClass = '';
        if(paramSort == k) {
          activeClass = 'active';
          activeSortTranslated = displayValue;
        }

        sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass+ '">' + displayValue + '</a></li>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ('.bc-sf-filter-custom-sorting').html(html);
      if(jQ('.bc-sf-filter-custom-sorting').hasClass("bc-sf-filter-sort-active")) {
        jQ('.bc-sf-filter-custom-sorting').toggleClass('bc-sf-filter-sort-active');
      }

      var labelSort = '';
      if(paramSort.length > 0) {
        // var labelHandle = 'sorting_' + paramSort.replace(/\-/g, '_');
        // labelSort = bcSfFilterConfig.label[labelHandle];
        var labelHandle = paramSort.replace(/\-/g, '_');
        labelSort = translatedSorted[labelHandle];
      } else {
        labelSort = bcSfFilterConfig.label.sorting;
      }

      jQ('.bc-sf-filter-custom-sorting label span span').text(activeSortTranslated);
    }
  }
};

// Build Sorting event
BCSfFilter.prototype.buildSortingEvent = function() {
  var _this = this;
  jQ('.bc-sf-filter-filter-dropdown a').click(function(e){
    e.preventDefault();
    onInteractWithToolbar(e, 'sort', _this.queryParams.sort, jQ(this).data('sort'));
  });

  jQ(".bc-sf-filter-custom-sorting > label").click(function(){
    if (!jQ('.bc-sf-filter-filter-dropdown').is(':animated')) {
      jQ('.bc-sf-filter-filter-dropdown').toggle().parent().toggleClass('bc-sf-filter-sort-active');
      jQ('#bc-sf-filter-tree').hide();
    }
  });

  jQ(this.getSelector('filterTreeMobileButton')).click(function(){
    jQ('#bc-sf-filter-top-sorting-mobile .bc-sf-filter-filter-dropdown').hide();
  });
};
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '<span>' + bcSfFilterConfig.label.toolbar_viewas + '</span>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  topDisplayTypeSelector.html(itemHtml);
  // Active current display type
  topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('active');
  if (this.queryParams.display == 'list') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
  } else if (this.queryParams.display == 'grid') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
  }
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  jQ(this.getSelector('topDisplayType') + ' a').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children().removeClass('active');
    jQ(this).addClass('active');
    if (_this.queryParams.display == 'list') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
    } else if (_this.queryParams.display == 'grid') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
    }
    var newUrl = jQ(this).attr('href');
    _this.onChangeData(newUrl, 'display');
  })
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = '';
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
    html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
    jQ(this.selector.breadcrumb).html(html);
  }
};
/************************** END BUILD TOOLBAR **************************/
function matchHeightImage() {
  jQ('.bc-sf-filter-product-item-main-image').load(function() {
    var imageContainer = jQ(this).parent();
    imageContainer.css('width', '100%').css('height', $(this).height());
  }).each(function() {
    if (this.complete) jQ(this).load();
  });
}
// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
    /* start-initialize-bc-al */
    var self = this;
    var alEnable = true;
    if(self.getSettingValue('actionlist.qvEnable') != '' || self.getSettingValue('actionlist.atcEnable') != ''){
      alEnable = self.getSettingValue('actionlist.qvEnable') || self.getSettingValue('actionlist.atcEnable');
    }
    if (alEnable === true && typeof BCActionList !== 'undefined') {
        if (typeof bcActionList === 'undefined') {
            bcActionList = new BCActionList();
        }else{
          if (typeof bcAlParams !== 'undefined' && typeof bcSfFilterParams !== 'undefined') {
              bcActionList.initFlag = false;
              bcActionList.alInit(bcSfFilterParams, bcAlParams);
          } else {
              bcActionList.alInit();
          }
        }
    }
    /* end-initialize-bc-al */
  // Call theme init function
  // if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
  //   $(theme.init);
  // }
  // End For List View
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  var _this = this;
  var totalProduct = data.total_product + '<span> ' + translations.products + '</span>';
  if (data.total_product == 1) {
    totalProduct = data.total_product + '<span> ' + translations.product + '</span>';
  }
  jQ('#bc-sf-filter-total-product').html(totalProduct);
  matchHeightImage();
  jQ(window).resize(function() {
    matchHeightImage();
  });

  jQ('body').find('.bc-sf-filter-skeleton-button').remove();

  // Prevent double tap on iOS
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isiOS){
    this.isMobile()&&jQ(".bc-sf-filter-product-item").find("a").on("touchstart",function(){isScrolling=!1}).on("touchmove",function(){isScrolling=!0}).on("touchend",function(){isScrolling||(window.location=jQ(this).attr("href"))});
  }

  // Fix image not loaded on mobile
  (this.isMobile()||null!=navigator.userAgent.match(/iPad/i))&&(setTimeout(function(){jQ(".bc-sf-filter-product-item-image img").each(function(){var a=jQ(this).attr("src")+"&";jQ(this).attr("src",a)})},200),setTimeout(function(){jQ(".bc-sf-filter-product-item-image img").each(function(){var a = jQ(this).attr("src");a = a.substring(0, a.indexOf('$collection_tile$') + '$collection_tile$'.length);jQ(this).attr("src",a)})},2e3));
};
// Translate Facets Values
if(typeof facets_translations !== "undefined") {
  BCSfFilter.prototype.buildFilterOptionLabel = function(a, b, c) {
    if(c.filterType == 'tag') {
      var prefix = c.prefix.replace('\\:','');
      var compare = prefix.replaceAll("_"," ").toLowerCase().split(' ').map(
        word => word.charAt(0).toUpperCase() + word.substring(1)
      ).join(' ');
      if(compare in facets_translations) {
         a = this.customizeFilterOptionLabel(a, c.prefix, c.filterType, c.displayAllValuesInUppercaseForm);
         a = a.replace(/\$/g, "&#36;");
          if(facets_translations[compare].options[a]) {
            a = facets_translations[compare].options[a];
          }
        } else {
         a = this.customizeFilterOptionLabel(a, c.prefix, c.filterType, c.displayAllValuesInUppercaseForm);
         a = a.replace(/\$/g, "&#36;");
        }
    } else if(c.filterType == "product_type" || c.filterType == "collection") {
      if(a in facets_translations.category_labels) {
		a = facets_translations.category_labels[a];
      }
    }
    
  
     var d = this.getTemplate("filterOptionLabel").replace(/{{itemValue}}/g, a);
     return this.getSettingValue("general.showFilterOptionCount") && "box" != c.displayType && !0 !== c.keepValuesStatic && null !== b && (b > 0 && 0 == this.getSettingValue("general.showOutOfStockOption") || 1 == this.getSettingValue("general.showOutOfStockOption")) ? d.replace(/{{itemAmount}}/g, "(" + b + ")") : d.replace(/{{itemAmount}}/g, "")
 }
}
function getParameterCaseInsensitive(object, key) {
  return object[Object.keys(object).filter(function(k) {
    return k.toLowerCase() === key.toLowerCase();
  })[0]];
}
// Translate Facet Values End
BCSfFilter.prototype.buildAll = function(data, isBuildFilterTree, eventType) {
  // Translate Facet Labels
  if(typeof facets_translations !== "undefined" && typeof data.filter !== "undefined") {
    jQ.each(data.filter.options, function(index, element) {
      if(element.filterType == 'tag') {
        var prefix = element.prefix.replace('\\:','');
        var compare = prefix.replaceAll("_"," ").toLowerCase().split(' ').map(
          word => word.charAt(0).toUpperCase() + word.substring(1)
        ).join(' ');
        var label_type = 'facet';
      } else {
        var facet_label_translation = getParameterCaseInsensitive(facets_translations.misc, element.label);
      }
      if(label_type == 'facet' && compare in facets_translations && facets_translations[compare].translation !== "undefined") {
        data.filter.options[index].label = facets_translations[compare].translation;
        jQ.each(element.values,function(vindex,velement) {
          var vcompare = velement.key.replace(prefix+':','');
          if(vcompare in facets_translations[compare].options) {
            data.filter.options[index].values[vindex].translatedKey = prefix + ":" + facets_translations[compare].options[vcompare];
          }
        });
      } else if(facet_label_translation !== 'undefined') {
      	data.filter.options[index].label = facet_label_translation; 
      }
    });
  }
  // Translate Facet Labels End
  var self = this;
    // Prepare data
    var paginationSelector = this.selector.pagination;
    var totalProduct = data.total_product;

    if (isBuildFilterTree === true && data.hasOwnProperty('filter')) {
        // Build Filter Tree
        this.buildFilterTree(data.filter.options);
        // Build Filter Selections
        if (this.getSettingValue('general.showRefineBy')) {
            this.buildFilterSelection(data);
        }
        // Customize Filter tree on mobile
        this.buildFilterTreeMobile();
        // Build Filter Tree Button for Mobile
        this.buildFilterTreeMobileButton(data);
        // Build events: clear filter option, clear all filter options and toggle on title
        this.buildAdditionalFilterEvent();
    }
    if (totalProduct > 0) {
        // Fix initial page load
        if(eventType == "init") {
          eventType = "status";
        }
      
        // Build Product List
        this.buildProductList(data.products, eventType);
        // Build Pagination
        var paginationType = this.getSettingValue('general.paginationType');
        if (paginationType == 'default') {
            this.buildPagination(totalProduct);
        } else {
            jQ(paginationSelector).empty();
            if (self.isLoadMorePaginationType()) {
              // Build load more button
              this.buildLoadMoreButton(totalProduct);
              // Build previous button
              this.buildLoadPreviousButton(totalProduct, eventType);
            }
        }
        // Build Toolbar
        this.buildToolbar();
        // Build Toolbar Event (Pagination, Sorting,...)
        this.buildToolbarEvent(data);
        // Hide Error Notification after build succesfully
        jQ(this.selector.filterWrapper).show();
        var topNotificationSelector = this.selector.topNotification;
        if (jQ(topNotificationSelector).length > 0) jQ(topNotificationSelector).empty();
    }

    // Show Products & Pagination after building (also used for Fallback)
    jQ(this.selector.products).removeAttr('data-bc-sort');
    jQ(paginationSelector).show();

    // Build Additional Elements
    this.buildAdditionalElements(data, eventType);

    // Build Scroll to Top
    this.buildScrollToTop();

    // Scroll to previous position when going back from product page
    this.scrollBackPositionHistoryBack();

    // Build Page information
    if (eventType == 'collection' || eventType == 'history') this.buildPageInfo(data);

    // Build Search
    if (this.isSearchPage()) {
        this.buildSEOTitle(data);
        this.buildSearchResultHeader(data);
        this.buildSearchResultNumber(data);
    }

    // Add Meta tag to exclude pages with filter params from Goolge crawl
    this.buildRobotsMetaTag(data);

    this.selectFilter = false;
};

// BCSfFilter.prototype.buildPageInfo = function(apiData) {
//   var self = this;

//   function buildContent(colData, apiData) {
//     self.buildBreadcrumb(colData, apiData);
//     self.buildCollectionDetail(colData, apiData);
//     self.buildDocumentInfo(colData, apiData);
//   }

//   var pathname = window.location.pathname;
//       console.log(pathname);
//   if (pathname != '/') {
//     var defaultColData = {
//       collection: { description: '', handle: bcSfFilterConfig.general.collection_handle, title: this.getSettingValue('label.collectionAll') }
//     };
//     // Collection "All" page
//     if (pathname == '/collections/all') {
//       buildContent(defaultColData, apiData);
//     }
//     // Vendor page
//     else if (this.isVendorPage()) {
//       var colData = {
//         collection: { description: '', handle: '', title: getParam('q') }
//       };
//       buildContent(colData, apiData);
//     }
//     // Type page
//     else if (this.isTypePage()) {
//       var colData = {
//         collection: { description: '', handle: '', title: getParam('q') }
//       };
//       buildContent(colData, apiData);
//     }
//     // All remaining pages, except Search page
//     else {
//       if (pathname != '/search') {
//         var collectionUrl = window.location.href.split('?')[0] + '?view=desc';
//         jQ.ajax({
//           method: 'GET',
//           url: collectionUrl,
//           dataType: 'json',
//           success: function(colData) {
//             buildContent(colData, apiData);
//           },
//           error: function() {
//             buildContent(defaultColData, apiData);
//           }
//         });
//       }
//     }
//   }
// };

// BCSfFilter.prototype.buildCollectionDetail = function(colData, apiData) {
//   console.log('2');
//   if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
//     // Get collection info
//     console.log(colData);
//     var colInfo = colData.collection;
//     var colTitle = colInfo.hasOwnProperty('title') && colInfo.title != '' ? colInfo.title : null;
//     var colDescription = colInfo.hasOwnProperty('description') && colInfo.description != '' ? colInfo.description : null;
//     // Selector
//     var collectionHeaderSelector = this.class.collectionHeader;
//     var collectionDescriptionSelector = this.class.collectionDescription;
//     // Build Collection Title
//     if (colTitle) {
//       jQ('.' + collectionHeaderSelector).html(colTitle).show();
//       // Deprecated
//       jQ('#' + collectionHeaderSelector).html(colTitle).show();
//     } else {
//       jQ('.' + collectionHeaderSelector).hide();
//       // Deprecated
//       jQ('#' + collectionHeaderSelector).hide();
//     }
//     // Build Collection Description
//     if (colDescription) {
//       jQ('.' + collectionDescriptionSelector).html(colDescription).show();
//       // Deprecated
//       jQ('#' + collectionDescriptionSelector).html(colDescription).show();
//     } else {
//       jQ('.' + collectionDescriptionSelector).hide();
//       // Deprecated
//       jQ('#' + collectionDescriptionSelector).hide();
//     }
//   }
// };


// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";if(searchQuery.length>0){window.location.replace(url+"?view=bc-original"+searchQuery)}}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData=function(data){var self=this;var countData=data.length;for(var k=0;k<countData;k++){data[k]["images"]=data[k]["images_info"];if(data[k]["images"].length>0){data[k]["featured_image"]=data[k]["images"][0]}else{data[k]["featured_image"]={src:bcSfFilterConfig.general.no_image_url,width:"",height:"",aspect_ratio:0}}data[k]["url"]="/products/"+data[k].handle;var optionsArr=[];var countOptionsWithValues=data[k]["options_with_values"].length;for(var i=0;i<countOptionsWithValues;i++){optionsArr.push(data[k]["options_with_values"][i]["name"])}data[k]["options"]=optionsArr;var firstVariant=data[k]["variants"][0];var isRoundedPrice=true;if(firstVariant.hasOwnProperty("fulfillment_service")&&firstVariant.fulfillment_service=="gift_card"){isRoundedPrice=false}if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){data[k].price_min=self.convertPriceBasedOnActiveCurrency(data[k].price_min,isRoundedPrice);data[k].price_max=self.convertPriceBasedOnActiveCurrency(data[k].price_max,isRoundedPrice);data[k].compare_at_price_min=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_min,isRoundedPrice);data[k].compare_at_price_max=self.convertPriceBasedOnActiveCurrency(data[k].compare_at_price_max,isRoundedPrice)}data[k]["price_min"]*=100,data[k]["price_max"]*=100;if(data[k]["compare_at_price_min"]!=null){data[k]["compare_at_price_min"]*=100}if(data[k]["compare_at_price_max"]!=null){data[k]["compare_at_price_max"]*=100}data[k]["price"]=data[k]["price_min"];data[k]["compare_at_price"]=data[k]["compare_at_price_min"];data[k]["price_varies"]=data[k]["price_min"]!=data[k]["price_max"];if(getParam("variant")!==null&&getParam("variant")!=""){var paramVariant=data[k]["variants"].filter(function(e){return e.id==getParam("variant")});if(typeof paramVariant[0]!=="undefined")firstVariant=paramVariant[0]}else{var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){if(data[k]["variants"][i].available){firstVariant=data[k]["variants"][i];break}}}data[k]["selected_or_first_available_variant"]=firstVariant;var countVariants=data[k]["variants"].length;for(var i=0;i<countVariants;i++){var variantOptionArr=[];var count=1;var variant=data[k]["variants"][i];var variantOptions=variant["merged_options"];if(Array.isArray(variantOptions)){var countVariantOptions=variantOptions.length;for(var j=0;j<countVariantOptions;j++){var temp=variantOptions[j].split(":");data[k]["variants"][i]["option"+(parseInt(j)+1)]=temp[1];data[k]["variants"][i]["option_"+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]["variants"][i]["options"]=variantOptionArr}if(data[k]["variants"][i]["compare_at_price"]!=null){var variantCompareAtPrice=parseFloat(data[k]["variants"][i]["compare_at_price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantCompareAtPrice=self.convertPriceBasedOnActiveCurrency(variantCompareAtPrice,isRoundedPrice)}data[k]["variants"][i]["compare_at_price"]=variantCompareAtPrice*100}var variantPrice=parseFloat(data[k]["variants"][i]["price"]);if(typeof self.convertPriceBasedOnActiveCurrency!=="undefined"){variantPrice=self.convertPriceBasedOnActiveCurrency(variantPrice,isRoundedPrice)}data[k]["variants"][i]["price"]=variantPrice*100}data[k]["description"]=data[k]["content"]=data[k]["body_html"];if(data[k].hasOwnProperty("original_tags")&&data[k]["original_tags"].length>0){data[k]["tags"]=data[k]["original_tags"].slice(0)}data[k]["json"]=customizeJsonProductData(data[k])}return data};
/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */

// Override function to append salesorg-status filter
BCSfFilter.prototype.getFilterParams = function(url) {
  var self = this,
    params = {},
    queryString = '';    

  /**
   * If url is undefined or false, set url = the queryString part of a URL
   */
  if (typeof url === 'undefined' || url === false) {
    url = window.location.search;
  }
  /**
   * Get query string from url from the first '?' character
   */
  if (url.indexOf('?') != -1) {
    queryString = url.split('?')[1];
  }

  if (typeof queryString !== 'undefined' && queryString != '') {
    /**
     * Remove ad params from the query string
     */
    queryString = self.removeAdParams(queryString);
    /**
     * Prepare params from the query string
     */
    if (queryString.length > 0) {
      var aKeyValue = '',
        i,
        aCouples = queryString.split('&'),
        lenACouples = aCouples.length;
      for (i = 0; i < lenACouples; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          var paramType = decodeURIComponent(aKeyValue[0]),
            paramValue = decodeURIComponent(aKeyValue[1].replace(/\+/g, '%20'));
          if (paramValue.indexOf('cache:') == -1) {
            if (params.hasOwnProperty(paramType)) {
              params[paramType].push(paramValue);
            } else {
              params[paramType] = self.findIndexArray(paramType, self.imutableFilterTree) > -1 || paramType == 'q' || paramType.indexOf('_and_condition') > -1 || paramType.indexOf('_show_exact_rating') > -1 ? paramValue : [paramValue];
            }
          }
          if (paramType.indexOf('pf_') > -1) {
            self.hasFilterOptionParam = true;
          }
        }
      }
    }
  }
  
  // Add salesorg-status filter based on currency
  if ( window.theme.ignoreSalesorg == false ) {
    if(Shopify.currency.active == "SEK" || Shopify.currency.active == "NOK") {
      params['pf_t_status'] = ["salesorg-status:0300-50","salesorg-status:0300-51","salesorg-status:0300-60"];
    } else if(Shopify.currency.active == "EUR" || Shopify.currency.active == "PLN" || Shopify.currency.active == "GBP") {
      params['pf_t_status'] = ["salesorg-status:0300-50","salesorg-status:0300-51","salesorg-status:0300-60"];
    } else if(Shopify.currency.active == "USD" || Shopify.currency.active == "CAD") {
      params['pf_t_status'] = ["salesorg-status:0020-50","salesorg-status:0020-51","salesorg-status:0020-60"];
    }
  }

  params['pf_t_master'] = ["group:master"];
  
  /**
   * return params;
   */
  return params;
};

BCSfFilter.prototype.checkFilterOptionSelected = function(paramType, paramValue, filterType, displayType) {
    // paramValue of a Collection filter option has format: collection_handle:collection_id
    // Whereas, the param of a Collection filter option in url is collection_handle
    // Split paramValue by ":" and get the first element to check if a collection is selected
    if (filterType == 'collection' && !this.isSearchPage()) paramValue = paramValue.split(':')[0];
  
  	//console.log(filterType, displayType, paramValue)

    // Compare each filter option value with params of url
    // Return "selected" if the value is existed in the array of params
    if (filterType == 'collection' && !this.isSearchPage()) {
        var pathName = decodeURIComponent(window.location.pathname);
        if (pathName.split('/').slice(2).join('/') == paramValue) return true;
    } else if (filterType == 'stock') {
        if (this.queryParams.hasOwnProperty(paramType)) {
            var param = this.queryParams[paramType];
            if (param.indexOf(paramValue.toString()) > -1) return true;
        }
    } else {
        if (this.queryParams.hasOwnProperty(paramType)) {
          var param = this.queryParams[paramType];
          if (displayType == 'sub_category') {
            if (this.queryParams.hasOwnProperty('tag')) {
	          	param = this.queryParams['tag'];
              	if (paramValue.indexOf('/') !== -1) {
                  paramValue = paramValue.split('/')[1];
                }
            } else if (paramValue.indexOf('/') === -1) {
           		paramValue = paramValue.split(':')[0];

            }
            
          }
          if (Array.isArray(param)) {
            for (var k = 0; k < param.length; k++) {
              if (param[k] == paramValue) {
                return true;
              }
            }
          } else {
            if (param == paramValue) return true;
          }
        }
    }
    return false;
};


BCSfFilter.prototype.buildFilterSelectionData = function(data) {
    function buildItem(template, title, label, clearLink) {
        template = template.replace(/{{itemType}}/g, title);
        template = template.replace(/{{itemLabel}}/g, label);
        template = template.replace(/{{itemLink}}/g, clearLink);
        return template;
    }

    var self = this;
    var selectionContent = '';
    var itemHtml = this.getSettingValue('general.refineByStyle') == 'style2' ? this.getTemplate('filterRefineItem2') : this.getTemplate('filterRefineItem');
    var options = data.filter.options;

    // Get all URL params: return all param keys start with "pf_"
    var paramKeys = Object.keys(self.queryParams);
    paramKeys = paramKeys.filter(function(key) {
        return key.indexOf('pf_') == 0
    });
	
  	// Remove salesorg-status tag from "Refine By" section
  	if(paramKeys.length > 0) {
      const index = paramKeys.indexOf("pf_t_status");
      if (index > -1) {
        paramKeys.splice(index, 1);
      }
  	} 
  	
    jQ.each(paramKeys, function(i, key) {
        var selectedOption = options.filter(function(e) { return e.filterOptionId == key })[0];
        if (typeof selectedOption !== 'undefined' && self.queryParams.hasOwnProperty(key) && self.queryParams[key] && self.queryParams[key].length) {
            var values = self.queryParams[key],
                fOId = selectedOption.filterOptionId,
                fType = selectedOption.filterType,
                fODisplayType = selectedOption.displayType,
                prefix = selectedOption.prefix,
                title = selectedOption.label;
            prefix = (typeof prefix !== 'undefined' && prefix !== null && prefix !== false) ? prefix.replace(/\\/g, '') : '';
            // Make sure values is an Array
            if (!Array.isArray(values)) values = [values];
            // Fix email campaign issue
            // values = values.map(function(value) {
            //     return value.toString().replace(/\+/g, '%20');
            // });
            if (fODisplayType == 'range') {
                /* RANGE SLIDER
                 *  - Is advanced range slider: Get first value and last value for min-max
                 *  - Is general range slider:  Split value by ":" to get min-max
                 **/
                var label = '';
                if ((fType.indexOf('price') == -1 && fType.indexOf('variants_price') == -1) && fType !== 'weight' && fType.indexOf('range_slider') == -1) {
                    // Return an Array of values
                    var rangeValues = []
                    if (selectedOption && selectedOption.hasOwnProperty('values')) {
                        rangeValues = selectedOption['values'].map(function(value) {
                            return value.key;
                        });
                    }
                    var currentLabels = rangeValues.length ? self.getAdvancedRangeSelectedValues(values, rangeValues) : [values[0], values[values.length - 1]];
                    label = currentLabels[0].toString().replace(prefix, '');
                    if (values.length > 1) {
                        label += ' - ' + currentLabels[1].toString().replace(prefix, '');
                    }
                    var clearLink = self.buildClearFilterOptionLink(fOId, title, values);
                } else {
                    var value = values[0],
                        elements = value.split(':');
                    if (fType == 'price' || fType == 'variants_price') {
                        var minPrice = self.formatMoney(elements[0] * 100),
                            maxPrice = self.formatMoney(elements[1] * 100);
                        if (self.getSettingValue('general.removePriceDecimal')) {
                            minPrice = self.removeDecimal(minPrice), maxPrice = self.removeDecimal(maxPrice);
                        }
                        label = minPrice + ' - ' + maxPrice;
                    } else {
                        label = elements[0] + ' - ' + elements[1];
                    }
                    var clearLink = self.buildClearFilterOptionLink(fOId, title, value);
                }
                selectionContent += buildItem(itemHtml, title, label, clearLink);
            } else {
                for (var i = 0; i < values.length; i++) {
                    var value = values[i],
                        label = value;
                    // Customize label
                    label = self.customizeFilterOptionLabel(label, prefix, fType);
                    var clearLink = self.buildClearFilterOptionLink(fOId, title, value);
                    // Remove the prefix in label
                    if (typeof prefix !== 'undefined' && prefix !== null && prefix !== false) {
                        prefix = prefix.replace(/\\/g, '');
                        value = value.replace(prefix, '').trim();
                    }

                    // console.log('fType', fType);
                    switch (fType) {
                        case 'price':
                        case 'variants_price':
                            label = self.getPriceLabel(value);
                            break;
                        case 'percent_sale':
                            label = self.getPercentSaleLabel(value);
                            break;
                        case 'stock':
                            label = (value === 'true') ? selectedOption.values[0].label : selectedOption.values[1].label;
                            break;
                        case 'review_ratings':
                            var showExactRating = selectedOption.hasOwnProperty('showExactRating') ? selectedOption.showExactRating : false;
                            label = self.getReviewRatingsLabel(value, showExactRating);
                            break;
                    }
                    selectionContent += buildItem(itemHtml, title, label, clearLink);
                }
            }
        }
    });

    var urlParam = window.location.search;
    if (urlParam !== '') {
        urlParam = urlParam.replace('?', '');
        var paramsArr = urlParam.split('&');
        if (paramsArr.indexOf('_=pf') !== -1) {
            paramsArr.splice(paramsArr.indexOf('_=pf'), 1);
        }
        if (jQ('#bc-sf-filter-params').length == 0) {
            jQ('body').append('<input type="hidden" id="bc-sf-filter-params" value="' + paramsArr.join('|') + '" />');
        } else {
            jQ('#bc-sf-filter-params').attr('value', paramsArr.join('|'));
        }
    }
    return selectionContent;
};
